import React from "react";
import { Link } from "react-router-dom";
import {
  MapPin, Navigation, ShieldCheck, ShoppingBag, Newspaper,
  Calculator, FileText, ExternalLink, ArrowRight,
} from "lucide-react";

const ICONS = {
  "map-pin": MapPin,
  navigation: Navigation,
  "shield-check": ShieldCheck,
  "shopping-bag": ShoppingBag,
  newspaper: Newspaper,
  calculator: Calculator,
  "file-text": FileText,
};

// Renders EVERMIN's action cards/buttons (Maps, Directions, official site,
// product/news access, calculator, document) below an answer.
export function ActionCards({ actions }) {
  if (!actions || actions.length === 0) return null;
  return (
    <div className="mt-3 flex flex-wrap gap-2" data-testid="action-cards">
      {actions.map((a, i) => {
        const Icon = ICONS[a.icon] || ExternalLink;
        const inner = (
          <>
            <Icon className="h-4 w-4 flex-shrink-0 text-primary" />
            <span className="truncate">{a.label}</span>
            {a.external ? <ExternalLink className="h-3 w-3 flex-shrink-0 text-slate-300" /> : <ArrowRight className="h-3 w-3 flex-shrink-0 text-slate-300" />}
          </>
        );
        const cls = "inline-flex max-w-full items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-medium text-slate-700 transition-colors hover:border-primary/40 hover:text-primary";
        return a.external ? (
          <a key={i} href={a.url} target="_blank" rel="noopener noreferrer" data-testid={`action-${a.type}`} className={cls}>
            {inner}
          </a>
        ) : (
          <Link key={i} to={a.url} data-testid={`action-${a.type}`} className={cls}>
            {inner}
          </Link>
        );
      })}
    </div>
  );
}
